// services/statistic-data/response/RevenueStatisticResponse.ts

import { z } from "zod";

// Skema untuk satu item dalam array 'data'
const RevenueStatisticItemSchema = z.object({
    name: z.string(),
    color: z.string(),
    revenue: z.coerce.number(), // Menggunakan coerce untuk memastikan tipe data number
});

// Skema untuk keseluruhan respons API
const RevenueStatisticResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(RevenueStatisticItemSchema),
});

// Ekspor tipe data yang di-infer dari skema
type RevenueStatisticResponse = z.infer<typeof RevenueStatisticResponseSchema>;
type RevenueStatisticData = z.infer<typeof RevenueStatisticResponseSchema>['data'];

export { RevenueStatisticResponseSchema };
export type { RevenueStatisticResponse, RevenueStatisticData };